import { Action } from 'shared/interface';
import { SET_PRIMARY_OVERVIEW_PANEL_VISIBLE } from './action-types';

const initialState = {
	isPrimaryPanelOverviewPanel: true,
};

const couponOverviewReducer = (state = initialState, action: Action) => {
	switch (action.type) {
		case SET_PRIMARY_OVERVIEW_PANEL_VISIBLE:
			return {
				...state,
				isPrimaryPanelOverviewPanel: action.payload,
			};
		default:
			return state;
	}
};

export default couponOverviewReducer;
